// @flow strict

import * as React from 'react';
import cx from 'classnames';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './styles.scss';

import PageContentBlock from '../../internal/PageContentBlock';
import ExpanderAnimation from '../../internal/ExpanderAnimation';
import FormattedContent from '../../internal/FormattedContent';

type PropTypes = {|
  title: string,
  id?: string,
  children: React.Node,
  theme: 'Low' | 'Medium' | 'High' | 'Dark',
  className?: string,
|};

export const ExpanderBase = (props: PropTypes) => {
  const expanderNode = React.useRef<null | HTMLDivElement>(null);
  const [open, toggle] = React.useState(false);
  const onClick = () => {
    toggle(!open);
  };

  React.useLayoutEffect(() => {
    if (
      props.id &&
      global.location &&
      global.location.hash &&
      `#${props.id}` === global.location.hash
    ) {
      if (!open) {
        toggle(true);
      }

      window.requestAnimationFrame(() => {
        if (open && expanderNode && expanderNode.current && props.id) {
          const elementToScroll = document.querySelector(`#${props.id}`);
          if (elementToScroll && elementToScroll.scrollIntoView) {
            elementToScroll.scrollIntoView({
              block: 'start',
              behavior: 'smooth',
              inline: 'nearest',
            });
          }
        }
      });
    }
  }, [props.id, global.location && global.location.hash, open, expanderNode]);

  return (
    <div className={cx(props.className, styles[`is${props.theme}`])} ref={expanderNode}>
      <button className={cx(styles.titleContainer, open && styles.isOpen)} onClick={onClick}>
        <h2>{props.title}</h2>
      </button>
      <div>
        <ExpanderAnimation open={open}>
          <div className={styles.content}>{props.children}</div>
        </ExpanderAnimation>
      </div>
    </div>
  );
};

const blockVariantMap = {
  Low: 'Featured',
  Medium: 'Default',
  High: 'DefaultContrast',
  Dark: 'Dark',
};

const Expander = (props: PropTypes) => (
  <PageContentBlock
    background={blockVariantMap[props.theme]}
    layout="Thin"
    className={styles.expanderPanel}
    id={props.id}
  >
    <ExpanderBase title={props.title} id={props.id} theme={props.theme} className={props.className}>
      <FormattedContent isDarkBackground={props.theme === 'Dark'}>
        {props.children}
      </FormattedContent>
    </ExpanderBase>
  </PageContentBlock>
);

Expander.defaultProps = {
  theme: 'Low',
};

ExpanderBase.defaultProps = {
  theme: 'Low',
};

export default Expander;
